var Vue = window['Vue'] || require('vue').default;

export default Vue;